import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsDatepickerConfig, BsDaterangepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ThemeHelper } from 'src/app/shared/layout/themes/ThemeHelper';

import { NgxBootstrapLocaleMappingService } from './ngx-bootstrap-locale-mapping.service';

export class NgxBootstrapDatePickerConfigService {
  static getDaterangepickerConfig(): BsDaterangepickerConfig {
    return Object.assign(new BsDaterangepickerConfig(), {
      containerClass: 'theme-' + NgxBootstrapDatePickerConfigService.getThemeColor(),
    });
  }

  static getDatepickerConfig(): BsDatepickerConfig {
    return Object.assign(new BsDatepickerConfig(), {
      containerClass: 'theme-' + NgxBootstrapDatePickerConfigService.getThemeColor(),
    });
  }

  static getThemeColor(): string {
    return ThemeHelper.getThemeColor();
  }

  static getDatepickerLocale(): BsLocaleService {
    const localeService = new BsLocaleService();
    localeService.use(eaf.localization.currentLanguage.name);
    return localeService;
  }

  static registerNgxBootstrapDatePickerLocales(): Promise<boolean> {
    // Inglês é o idioma padrão, não precisa de importação adicional
    if (eaf.localization.currentLanguage.name === 'en') {
      return Promise.resolve(true);
    }

    // Para português do Brasil
    if (eaf.localization.currentLanguage.name.toLowerCase() === 'pt-br' || eaf.localization.currentLanguage.name.toLowerCase() === 'pt') {
      return new Promise<boolean>(resolve => {
        import('ngx-bootstrap/locale')
          .then(module => {
            defineLocale('pt-br', module.ptBrLocale);
            resolve(true);
          })
          .catch(error => {
            console.error('Failed to load pt-br locale:', error);
            resolve(false);
          });
      });
    }
    // Para espanhol
    else if (
      eaf.localization.currentLanguage.name.toLowerCase() === 'es' ||
      eaf.localization.currentLanguage.name.toLowerCase() === 'es-mx'
    ) {
      return new Promise<boolean>(resolve => {
        import('ngx-bootstrap/locale')
          .then(module => {
            defineLocale('es', module.esLocale);
            resolve(true);
          })
          .catch(error => {
            console.error('Failed to load es locale:', error);
            resolve(false);
          });
      });
    }
    // Para outros idiomas
    else {
      const supportedLocale = new NgxBootstrapLocaleMappingService().map(eaf.localization.currentLanguage.name).toLowerCase();
      const moduleLocaleName = new NgxBootstrapLocaleMappingService().getModuleName(eaf.localization.currentLanguage.name);

      return new Promise<boolean>(resolve => {
        import('ngx-bootstrap/locale')
          .then(module => {
            if (module[`${moduleLocaleName}Locale`]) {
              defineLocale(eaf.localization.currentLanguage.name.toLowerCase(), module[`${moduleLocaleName}Locale`]);
              resolve(true);
            } else {
              console.warn(`Locale ${moduleLocaleName} not found in ngx-bootstrap/locale, falling back to English`);
              resolve(false);
            }
          })
          .catch(error => {
            console.warn(`Could not load locale ${supportedLocale}, falling back to English:`, error);
            resolve(false);
          });
      });
    }
  }
}
